import React from "react";
import styles from "./AboutLoveWallet.module.scss";
import Image from "next/image";
import { AiFillHeart } from "react-icons/ai";
import Link from "next/link";

const AboutLoveWallet = () => {
  return (
    <section className={styles.aboutLoveWallet}>
      <div className={styles.blobRight} />
      <div className={styles.blobBottom} />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Native Token <br /> of{' '}
            <span className={styles.titleSpan}>Love Wallet</span>
          </h1>

          <p className={styles.paraghraph}>
            Love Wallet is the official wallet for BLV Token.
          </p>

          <div className={styles.flexContent}>
            <div>
              <AiFillHeart color='#E80000' />
            </div>
            <p className={styles.text}>
              BLove token is the native token of Love Wallet.
            </p>
          </div>
          <div className={styles.flexContent}>
            <div>
              <AiFillHeart color='#E80000' />
            </div>
            <p className={styles.text}>
              Love Wallet is a decentralized multi-chain wallet to store & swap
              crypto coins & NFTs.
            </p>
          </div>

          <div className={styles.qrcode}>
            <Link
              href='https://play.google.com/store/apps/details?id=com.application.bfic&hl=en&gl=US'
              target='_blank'
            >
              <button className={styles.btn}>Download App</button>
            </Link>
            <Image
              alt='qr'
              src='/assets/Image/qr.png'
              width={90}
              height={90}
            />
          </div>
        </div>
        <div className={styles.image}>
          <Image
            src='/assets/Image/loveWalletMobile.png'
            width={600}
            height={525}
            priority
            alt='image'
            className={styles.img}
          />
        </div>
      </div>
    </section>
  )
};

export default AboutLoveWallet;
